import { render, staticRenderFns } from "./AccrualsData.vue?vue&type=template&id=b1812882&scoped=true"
import script from "./AccrualsData.vue?vue&type=script&lang=js"
export * from "./AccrualsData.vue?vue&type=script&lang=js"
import style0 from "./AccrualsData.vue?vue&type=style&index=0&id=b1812882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1812882",
  null
  
)

export default component.exports